export enum RoleDb {
  N8N = 'N8N',
}
